module.exports = __webpack_public_path__ + "static/webstorm3-9594374c5d48a2fffaa3a505597d8c18.png";